import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/nl"; // Import the Dutch locale data

dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
dayjs.extend(utc);

// Force Sunday as first day of week
dayjs.updateLocale("nl", {
  weekStart: 0, // 0 = Sunday
});

dayjs.locale("nl"); // Corrected to pass the locale string as "nl"

export default dayjs;
